import type { TeamSearchFields } from '../../types';
import { mailingAddressHasValidGeolocation } from '../../utils/location';

export function computeViewAllTeamsBounds(teams: TeamSearchFields[]) {
  const addresses = teams
    .map((team) => team.mailingAddress)
    .filter(mailingAddressHasValidGeolocation);

  if (!addresses.length) {
    return null;
  }

  return addresses.reduce(
    (bounds, address) =>
      bounds.extend({
        lat: Number(address?.geolocationLatitude),
        lng: Number(address?.geolocationLongitude),
      }),
    new google.maps.LatLngBounds(),
  );
}
